import { TENANT } from "@/lib/tenant";

export function SettingsRoute() {
  return (
    <div className="flex flex-col gap-md">
      <h1 className="font-display text-3xl tracking-tight">Inställningar</h1>
      <dl className="bg-surface border border-surfaceMuted rounded-md p-md grid grid-cols-[max-content_1fr] gap-x-lg gap-y-sm text-sm">
        <dt className="text-textSecondary">Vårdgivare</dt>
        <dd>{TENANT.partnerClinic.name ?? "Ej angiven"}</dd>
        <dt className="text-textSecondary">Tenant</dt>
        <dd>
          <code className="text-xs">{TENANT.id}</code>
        </dd>
        <dt className="text-textSecondary">Standardspråk</dt>
        <dd>{TENANT.locales.default}</dd>
      </dl>
    </div>
  );
}
